import { FiFileText } from "react-icons/fi";
import { RevisionFileList } from "./RevisionFileList";
import type { RevisionFile } from "../../../types/scoring.type";

interface RevisionPaneProps {
	files: RevisionFile[];
}

export const RevisionPane = ({ files }: RevisionPaneProps) => {
	return (
		<div data-testid="revision-pane">
			<div className="flex items-center gap-2 mb-3">
				<FiFileText size={16} className="text-gray-400" aria-hidden="true" />
				<h4 className="text-sm font-medium text-gray-700">Revisions</h4>
				{files.length > 0 && (
					<span className="text-xs text-gray-400">({files.length})</span>
				)}
			</div>

			{files.length === 0 ? (
				<div
					className="rounded-lg border border-dashed border-gray-300 p-6 text-center text-sm text-gray-400"
					data-testid="revision-pane-empty"
				>
					No revisions for this supplier.
				</div>
			) : (
				<RevisionFileList files={files} />
			)}
		</div>
	);
};
